export default {
  submitButtonContinue: {
    id: 'review_funnel_submit_button_continue',
    defaultMessage: 'Continue',
  },
  submitButtonUpload: {
    id: 'review_funnel_submit_button_upload',
    defaultMessage: 'Upload media',
  },
} as const
